
import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Tooltip } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";
import ShareIcon from "@mui/icons-material/Share";
import { formatNumber } from "utils/numberUtils";
import MDBox from "components/MDBox";

const Footer = ({ platform, entityObject }) => {
  const getMetrics = () => {
    if (platform === "YouTube") {
      const { viewCount = 0, likeCount = 0, commentCount = 0 } = entityObject.videoMetrics || {};
      return {
        views: viewCount,
        likes: likeCount,
        comments: commentCount,
        shares: null, // not applicable
      };
    }

    if (platform === "Facebook") {
      const {
        likes = 0,
        like = 0,
        love = 0,
        wow = 0,
        haha = 0,
        sad = 0,
        angry = 0,
        comments = 0,
        shares = 0,
      } = entityObject.postMetrics || {};

      const totalReactions = likes + like + love + wow + haha + sad + angry;

      return {
        views: null, // not available
        likes: totalReactions,
        comments,
        shares,
      };
    }

    if (platform === "Instagram") {
      const {
        likes = 0,
        comments = 0,
        views = 'NA',
      } = entityObject.postMetrics || {};

      return {
        views, // Placeholder
        likes,
        comments,
        shares: null,
      };
    }

    return {
      views: "-",
      likes: "-",
      comments: "-",
      shares: null,
    };
  };

  const metrics = getMetrics();

  return (
    <MDBox
      display="flex"
      justifyContent="space-around"
      alignItems="flex-start"
      borderTop="1px solid #eee"
      px={1}
      py={0.5}
      // bgColor="white"
    >
      {/* Likes */}
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.25}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Tooltip title="Likes" arrow>
            <FavoriteIcon fontSize="small" sx={{ color: "#888" }} />
          </Tooltip>
          <Tooltip title={typeof metrics.likes === "number" ? metrics.likes.toLocaleString() : metrics.likes} arrow>
            <Typography variant="caption" sx={{ color: '#000', fontWeight: 'bold' }}>
              {typeof metrics.likes === "number" ? formatNumber(metrics.likes) : metrics.likes}
            </Typography>
          </Tooltip>
        </Box>
        <Typography variant="caption" fontSize="10px" sx={{ color: '#000', fontWeight: 'bold' }}>
          REACTIONS
        </Typography>
      </Box>

      {/* Comments */}
      <Box display="flex" flexDirection="column" alignItems="center" gap={0.25}>
        <Box display="flex" alignItems="center" gap={0.5}>
          <Tooltip title="Comments" arrow>
            <ChatBubbleIcon fontSize="small" sx={{ color: "#888" }} />
          </Tooltip>
          <Tooltip title={typeof metrics.comments === "number" ? metrics.comments.toLocaleString() : metrics.comments} arrow>
            <Typography variant="caption" sx={{ color: '#000', fontWeight: 'bold' }}>
              {typeof metrics.comments === "number" ? formatNumber(metrics.comments) : metrics.comments}
            </Typography>
          </Tooltip>
        </Box>
        <Typography variant="caption" fontSize="10px" sx={{ color: '#000', fontWeight: 'bold' }}>
          COMMENTS
        </Typography>
      </Box>

      {/* Shares */}
      {metrics.shares !== null && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={0.25}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Tooltip title="Shares" arrow>
              <ShareIcon fontSize="small" sx={{ color: "#888" }} />
            </Tooltip>
            <Tooltip title={typeof metrics.shares === "number" ? metrics.shares.toLocaleString() : metrics.shares} arrow>
              <Typography variant="caption" sx={{ color: '#000', fontWeight: 'bold' }}>
                {typeof metrics.shares === "number" ? formatNumber(metrics.shares) : metrics.shares}
              </Typography>
            </Tooltip>
          </Box>
          <Typography variant="caption" fontSize="10px" sx={{ color: '#000', fontWeight: 'bold' }}>
            SHARES
          </Typography>
        </Box>
      )}

      {/* Views */}
      {metrics.views !== null && (
        <Box display="flex" flexDirection="column" alignItems="center" gap={0.25}>
          <Box display="flex" alignItems="center" gap={0.5}>
            <Tooltip title="Views" arrow>
              <VisibilityIcon fontSize="small" sx={{ color: "#888" }} />
            </Tooltip>
            <Tooltip title={typeof metrics.views === "number" ? metrics.views.toLocaleString() : metrics.views} arrow>
              <Typography variant="caption" sx={{ color: '#000', fontWeight: 'bold' }}>
                {typeof metrics.views === "number" ? formatNumber(metrics.views) : metrics.views}
              </Typography>
            </Tooltip>
          </Box>
          <Typography variant="caption" fontSize="10px" sx={{ color: '#000', fontWeight: 'bold' }}>
            VIEWS
          </Typography>
        </Box>
      )}
    </MDBox>

  );
};

Footer.propTypes = {
  platform: PropTypes.string.isRequired,
  entityObject: PropTypes.object.isRequired,
};

export default Footer;
